import {CreateInstance} from './config'
const GetMgridAPI = CreateInstance('GetMgridAPI')
export default GetMgridAPI
